import { render, staticRenderFns } from "./KaartNavigatie.vue?vue&type=template&id=1a9c1fa0&scoped=true&"
import script from "./KaartNavigatie.vue?vue&type=script&lang=js&"
export * from "./KaartNavigatie.vue?vue&type=script&lang=js&"
import style0 from "./KaartNavigatie.vue?vue&type=style&index=0&id=1a9c1fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c1fa0",
  null
  
)

export default component.exports